// extracted by mini-css-extract-plugin
export var alignCenter = "_7a-d";
export var bannerShown = "_7a-6";
export var buttonContent = "_7a-0";
export var cardList = "_7a-1";
export var centerContent = "_7a-2";
export var chevron = "_7a-3";
export var closePanelButton = "_7a-k";
export var conversationContextContainer = "_7a-l";
export var conversationDetailContainer = "_7a-4";
export var detailWrapper = "_7a-7";
export var dropdownButton = "_7a-e";
export var dropdownTitle = "_7a-9";
export var fullHeight = "_7a-5";
export var hidden = "_7a-a";
export var icon = "_7a-b";
export var mergeSuggestionWrapper = "_7a-m";
export var panel = "_7a-i";
export var portalButtonsWrapper = "_7a-c";
export var right = "_7a-j";
export var tableSummaryContainer = "_7a-8";
export var tableSummaryHeader = "_7a-g";
export var threeDotsButton = "_7a-f";
export var wide = "_7a-h";